module.exports = __webpack_public_path__ + "static/img/map2.23858ba7.png";